
// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const Support = () => {

//   const [name, setName] = useState("");
//   const [email, setEmail] = useState("");
//   const [message, setMessage] = useState("");
//   const [loading, setLoading] = useState(false);

//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {

//     e.preventDefault();

//     try {

//       setLoading(true);

//       const response = await axios.post(
//         "https://api.scannscore.com/inquiry",
//         {
//           name: name,
//           email: email,
//           message: message
//         }
//       );

//       alert(response.data.message || "Inquiry submitted successfully");

//       setName("");
//       setEmail("");
//       setMessage("");

//     } catch (error) {

//       console.error(error);

//       alert("Failed to submit inquiry");

//     } finally {

//       setLoading(false);

//     }

//   };

//   return (

//     <div
//       className="d-flex justify-content-center align-items-center"
//       style={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f0f4ff, #d9e6ff)"
//       }}
//     >

//       <div
//         className="card shadow-lg p-4"
//         style={{
//           maxWidth: "500px",
//           width: "100%",
//           borderRadius: "15px",
//           boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
//           border: "none",
//         }}
//       >

    
//         <div
//           style={{
//             background: "linear-gradient(90deg, #2F49cF, #4a6fff)",
//             padding: "20px",
//             borderRadius: "15px 15px 0 0",
//             color: "#fff",
//             textAlign: "center",
//             marginBottom: "20px",
//             fontWeight: "600",
//             fontSize: "1.5rem",
//           }}
//         >
//           Support Inquiry
//         </div>

//         <p className="text-center text-muted mb-4" style={{ fontSize: "0.95rem" }}>
//           If you have any issues or questions, please fill out the form below.
//           Our team will get back to you shortly.
//         </p>

//         <form onSubmit={handleSubmit}>

        
//           <div className="mb-3">
//             <input
//               type="text"
//               className="form-control"
//               placeholder="Full Name"
//               value={name}
//               onChange={(e) => setName(e.target.value)}
//               required
//             />
//           </div>

       
//           <div className="mb-3">
//             <input
//               type="email"
//               className="form-control"
//               placeholder="Email Address"
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               required
//             />
//           </div>

//           <div className="mb-3">
//             <textarea
//               className="form-control"
//               placeholder="Your Message"
//               rows="5"
//               value={message}
//               onChange={(e) => setMessage(e.target.value)}
//               required
//             />
//           </div>


//           <div className="d-flex justify-content-between mt-4">

//             <button
//               type="submit"
//               className="btn"
//               disabled={loading}
//               style={{
//                 width: "48%",
//                 background: "linear-gradient(90deg, #2F49cF, #4a6fff)",
//                 color: "#fff",
//                 borderRadius: "10px",
//                 fontWeight: "500"
//               }}
//             >
//               {loading ? "Submitting..." : "Submit Inquiry"}
//             </button>

//             <button
//               type="button"
//               className="btn btn-outline-secondary"
//               style={{
//                 width: "48%",
//                 borderRadius: "10px",
//                 fontWeight: "500"
//               }}
//               onClick={() => navigate(-1)}
//             >
//               Back
//             </button>

//           </div>

//         </form>

//       </div>

//     </div>

//   );

// };

// export default Support;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FaBolt, FaComments, FaLock } from "react-icons/fa";
import { FaUser, FaEnvelope, FaCommentDots, FaPaperPlane } from "react-icons/fa";

const Support = () => {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setLoading(true);

      const response = await axios.post(
        "https://api.scannscore.com/inquiry",
        { name, email, message }
      );

      alert(response.data.message || "Inquiry submitted successfully");

      setName("");
      setEmail("");
      setMessage("");

    } catch (error) {

      alert("Failed to submit inquiry");

    } finally {

      setLoading(false);

    }

  };

  return (

    <div
      style={{
        minHeight: "100vh",
        background:
          "linear-gradient(135deg,#5f72ff,#9b23ea)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px"
      }}
    >

      <div
        className="row"
        style={{
          maxWidth: "1000px",
          width: "100%",
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 30px 60px rgba(0,0,0,0.25)"
        }}
      >


        <div
          className="col-md-5 d-flex flex-column justify-content-center"
          style={{
            background:
              "linear-gradient(160deg,#5f72ff,#9b23ea)",
            color: "#fff",
            padding: "40px"
          }}
        >

          <h2 style={{ fontWeight: "700" }}>
            Need Help?
          </h2>

          <p style={{ opacity: "0.9" }}>
            Our support team is here to help you with any issue.
            Send us a message and we will respond quickly.
          </p>
<div style={{ marginTop: "20px", fontSize: "14px", opacity: "0.9" }}>

  <div className="d-flex align-items-center mb-2">
    <FaBolt style={{ marginRight: "8px" }} />
    Fast Response
  </div>

  <div className="d-flex align-items-center mb-2">
    <FaComments style={{ marginRight: "8px" }} />
    Friendly Support
  </div>

  <div className="d-flex align-items-center">
    <FaLock style={{ marginRight: "8px" }} />
    Secure Communication
  </div>

</div>

        </div>

      

        <div
          className="col-md-7"
          style={{ padding: "40px" }}
        >

          <h4 className="mb-4" style={{ fontWeight: "600" }}>
            Support Inquiry
          </h4>

          <form onSubmit={handleSubmit}>



            <div className="mb-3 position-relative">

              <FaUser
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "12px",
                  transform: "translateY(-50%)",
                  color: "#888"
                }}
              />

              <input
                type="text"
                className="form-control"
                placeholder="Full Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{
                  paddingLeft: "40px",
                  borderRadius: "10px"
                }}
              />

            </div>

    
            <div className="mb-3 position-relative">

              <FaEnvelope
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "12px",
                  transform: "translateY(-50%)",
                  color: "#888"
                }}
              />

              <input
                type="email"
                className="form-control"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  paddingLeft: "40px",
                  borderRadius: "10px"
                }}
              />

            </div>

       

            <div className="mb-4 position-relative">

              <FaCommentDots
                style={{
                  position: "absolute",
                  top: "15px",
                  left: "12px",
                  color: "#888"
                }}
              />

              <textarea
                className="form-control"
                rows="5"
                placeholder="Write your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                style={{
                  paddingLeft: "40px",
                  borderRadius: "10px",
                  resize: "none" 
                }}
              />

            </div>

            <div className="d-flex gap-3">

              <button
                type="submit"
                disabled={loading}
                className="btn flex-grow-1"
                style={{
                  background:
                    "linear-gradient(90deg,#5f72ff,#9b23ea)",
                  color: "#fff",
                  fontWeight: "600",
                  borderRadius: "10px",
                  padding: "10px"
                }}
              >
                {loading ? "Submitting..." : (
                  <>
                    <FaPaperPlane style={{ marginRight: "6px" }} />
                    Send Message
                  </>
                )}
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary flex-grow-1"
                style={{ borderRadius: "10px" }}
                onClick={() => navigate(-1)}
              >
                Back
              </button>

            </div>

          </form>

        </div>

      </div>

    </div>

  );

};

export default Support;